import { useNotificationStore } from '../store/notificationStore';

export function NotificationCenter() {
  const queue = useNotificationStore((s) => s.queue);
  const dismiss = useNotificationStore((s) => s.dismiss);

  if (queue.length === 0) return null;

  return (
    <div
      role="log"
      aria-live="polite"
      aria-label="通知中心"
      data-testid="notification-center"
      className="pointer-events-none fixed right-4 bottom-16 z-50 flex w-80 flex-col gap-2"
    >
      {queue.map((n) => (
        <div
          key={n.id}
          role="status"
          className={toneClass(n.level)}
          data-testid="notification-item"
        >
          <span className="flex-1 text-sm">{n.message}</span>
          <button
            type="button"
            aria-label="dismiss"
            className="text-foreground-muted hover:text-foreground"
            onClick={() => dismiss(n.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

function toneClass(level: string | undefined): string {
  const base =
    'pointer-events-auto flex items-center gap-2 rounded border bg-surface px-3 py-2 shadow';
  switch (level) {
    case 'success':
      return `${base} border-success/40 text-foreground`;
    case 'warning':
      return `${base} border-warning/40 text-foreground`;
    case 'danger':
      return `${base} border-danger/40 text-foreground`;
    default:
      return `${base} border-border text-foreground`;
  }
}
